class ProductEngraving extends HTMLElement {
    constructor() {
        super();

        // elements
        this.variantIds = this.getAttribute('data-variant-id');
        this.enravingInput = this.querySelector('input[data-engraving-message]');
    }

    connectedCallback() {
        // add event listeners
        document.addEventListener('variant:engraving', this.reloadEngravingSection.bind(this));

        // add input event listeners
        this.enravingInput.addEventListener('keyup', this.manageEngravingCheckoutInfos.bind(this));
    }   

    disconnectedCallback() {
        // remove event listeners
        document.removeEventListener('variant:engraving', this.reloadEngravingSection.bind(this));

        // remove input event listeners
        this.enravingInput.removeEventListener('keyup', this.manageEngravingCheckoutInfos.bind(this));
    }

    reloadEngravingSection(event) {

        if( this.variantIds.indexOf(event.detail.variant.id) !== -1 ) {
            this.classList.remove('section-loading', 'tw-hidden');

            // update checkout field with input value
            this.manageEngravingCheckoutInfos();
        }
        else {
            this.classList.add('section-loading', 'tw-hidden');

            // reset checkout field
            document.querySelectorAll('[data-checkout-engraving-message]').forEach(input => {
                input.value = '';
            });
        }
    }

    manageEngravingCheckoutInfos() {
        // Avis complexe
        document.querySelectorAll('[data-checkout-engraving-message]').forEach(input => {
            input.value = this.enravingInput.value;
        });
    }
}

if( !customElements.get('product-engraving') ) {
    customElements.define('product-engraving', ProductEngraving);
}